import { render, staticRenderFns } from "./Firststep.vue?vue&type=template&id=30e50a70&scoped=true&"
import script from "./Firststep.vue?vue&type=script&lang=js&"
export * from "./Firststep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e50a70",
  null
  
)

export default component.exports